module.exports = __webpack_public_path__ + "img/game_phone_zh.0b4874ce.png";